import React from 'react';
import get from 'lodash/get';
import dynamic from 'next/dynamic';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { limitText } from '../../../components/LatestNewsSection/utils';
import { FormattedMessage } from '../../../util/reactIntl';
import NewsImage from '../../../components/NewsImage/NewsImage';
import NewsLink from '../../../components/NewsLink/NewsLink';
import { IconEdit, IconDelete } from '../../../components';

import css from './PostsSection.module.scss';

const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
      ssr: false,
    });

const News = props => {

  const {
    news,
    handleEditPopup,
    isOwnListing,
    isPreview,
    intl
  } = props;

  const screenWidth = typeof window !== 'undefined' && window.innerWidth;
  const slidesToShow = screenWidth && screenWidth < 768 ? 1.3 : 2.3;

  return (
    <>
      {!!news?.[0] && (
        <div className={css.wrapper} key="newsSwiper">
          <h2 className={css.descriptionTitle}>
            <FormattedMessage id="ListingPage.newsTitle" />
          </h2>
          <div className={css.newsWrapper}>

            <Swiper
              modules={[Navigation]}
              navigation={{
                nextEl: '.custom_next',
                prevEl: '.custom_prev',
              }}
              spaceBetween={10}
              slidesPerView={slidesToShow}
              onSwiper={swiper => { }}
              onSlideChange={() => { }}
            >
              <div className="custom_next">
                <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
              </div>
              <div className="custom_prev">
                <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
              </div>
              {news.map((n, index) => {
                const title = get(n, 'title', '');
                const link = get(n, 'link', null);
                const imgUrl = get(n, 'image.url', null);

                return (
                  <SwiperSlide key={`${n.title}-${index}`}>

                    <div key={index?.toString()} className={css.newsItem}>
                      {isOwnListing && (
                        <div className={css.actionButtons}>

                          <div
                            className={css.actionButton}
                            onClick={() => isPreview ? alert(intl.formatMessage({id: 'PreviewPopup.previewMode'})) : handleEditPopup(true, false, 'news', index)}>
                            <IconEdit size="big" />
                          </div>

                          <span
                            className={css.actionButton}
                            onClick={() => isPreview ? alert(intl.formatMessage({id: 'PreviewPopup.previewMode'})) : handleEditPopup(false, true, 'news', index)}
                          >
                            <IconDelete />
                          </span>
                        </div>
                      )}
                      {link ? (
                        <NewsLink
                          className={css.title}
                          link={link}
                        >
                          {title}
                        </NewsLink>
                      ) : (
                        <span className={css.title}>{title}</span>
                      )}
                      <NewsImage
                        imgUrl={imgUrl}
                        link={link}
                        imageClassName={css.image}
                        iconClassName={css.newsIcon}
                      />
                      <p className={css.description}>{limitText(n?.description, 100)}</p>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      )}
    </>
  );
};

export default News;
